import styled from '@emotion/styled';
import theme from '~/theme';
import React from 'react';
import { getSectionSpacing } from '~/utilities/spacing';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
    position: relative;

    background-color: white;
    padding: 35px;
    border-radius: 35px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);

    ${({ marginBottom }) => getSectionSpacing(marginBottom, 'margin-bottom')};
    ${({ css }) => css};

    @media (min-width: ${theme.breakpoint.largeTablet}) {
        padding: 28px 50px 45px;
    }

    @media (min-width: ${theme.breakpoint.largeTablet}) {
        padding: 35px 65px 55px;
    }
`;

const Panel = ({ css = '', children, marginBottom = 'none' }) => {
    return <Wrapper {...{ css, marginBottom }}>{children}</Wrapper>;
};

Panel.propTypes = {
    children: PropTypes.node.isRequired,
    css: PropTypes.string,
    marginBottom: PropTypes.string
};

export default Panel;
